import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center px-4">
        <p className="text-8xl font-heading font-bold text-rsc-navy/10">404</p>
        <h1 className="text-3xl font-heading font-bold text-rsc-navy mt-4">Page Not Found</h1>
        <p className="text-lg text-muted-foreground mt-2 max-w-md mx-auto">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center mt-8">
          <Link to="/"><Button><Home className="h-4 w-4 mr-2" /> Go Home</Button></Link>
          <Button variant="outline" onClick={() => window.history.back()}><ArrowLeft className="h-4 w-4 mr-2" /> Go Back</Button>
        </div>
      </div>
    </div>
  );
}
